import { Component, HostBinding, Input } from '@angular/core';
import { Router } from '@angular/router';

export interface BreadcrumbItem {
  label: string;
  route?: string | string[]; // Ruta opcional para navegación
  queryParams?: object; // Query params opcionales
}

@Component({
  selector: 'ian-header-toolbar',
  templateUrl: './ian-header-toolbar.component.html',
  styleUrls: ['./ian-header-toolbar.component.scss'],
})
export class IanHeaderToolbarComponent {
  @Input()
  heading: string;

  @Input()
  title: string;

  @Input()
  popOverTitle: string;

  @Input()
  popOverText: string;

  @Input()
  subTitle: string;

  @Input()
  toolbarType: number;

  @Input()
  returnToUrl: string; // si viene vacio no se muestra el boton con la flecha

  @Input()
  returnToUrlinkParams: object;

  @Input()
  breadcrumb: (string | BreadcrumbItem)[]; // Array de strings o objetos con label y route

  /** PRICING-S06: fijar el header del form al scrollear el contenido. */
  @Input()
  sticky = false;

  @HostBinding('class.ian-header-toolbar--host-sticky')
  get hostStickyClass(): boolean {
    return !!this.sticky;
  }

  constructor(private router: Router) {}

  /**
   * Normaliza el breadcrumb para trabajar con strings u objetos
   */
  getBreadcrumbItem(item: string | BreadcrumbItem, index: number): BreadcrumbItem {
    if (typeof item === 'string') {
      return { label: item };
    }
    return item;
  }

  /**
   * Navega a la ruta del breadcrumb si está disponible
   */
  navigateToBreadcrumb(item: string | BreadcrumbItem): void {
    if (typeof item === 'object' && item.route) {
      const route = Array.isArray(item.route) ? item.route : [item.route];
      if (item.queryParams) {
        this.router.navigate(route, { queryParams: item.queryParams });
      } else {
        this.router.navigate(route);
      }
    }
  }

  /**
   * Verifica si un item del breadcrumb es clickeable
   */
  isClickable(item: string | BreadcrumbItem): boolean {
    return typeof item === 'object' && !!item.route;
  }

  /**
   * Retorna el breadcrumb sin el último elemento (el paso actual)
   */
  getBreadcrumbItems(): (string | BreadcrumbItem)[] {
    if (!this.breadcrumb || this.breadcrumb.length <= 1) {
      return this.breadcrumb || [];
    }
    // Retorna todos los elementos excepto el último
    return this.breadcrumb.slice(0, -1);
  }
}
